export enum D365CustomerSegment {
    Residential = 100000000,
    Microbusiness = 100000001,
    // Condominio = 685980000 // Predisposto per il futuro 🤠
}
